import Dialog from './Dialog'
export default Dialog


// WEBPACK FOOTER //
// ./src/modules/Dialog/index.js